import { parseAsStringEnum, useQueryStates } from "nuqs";

import { usePagination } from "@/shared/hooks";
import type { AdminSession } from "../models";
import {
  ADMIN_SESSION_STATUS,
  getSessionStatusLabel,
  SESSION_CATEGORY,
  SESSION_STATUS,
} from "../models";
import { useSessionCategory } from "./use-session-category";

export const useSessionStatus = () => {
  const [tab, setTab] = useQueryStates(
    {
      status: parseAsStringEnum(
        Object.values(ADMIN_SESSION_STATUS),
      ).withDefault(ADMIN_SESSION_STATUS.UPCOMING),
    },
    {
      urlKeys: {
        status: "tab",
      },
    },
  );

  const setStatus = (status: string) => {
    if (
      Object.values(ADMIN_SESSION_STATUS).includes(
        status as AdminSession["status"],
      )
    ) {
      return setTab({ status: status as AdminSession["status"] });
    }
    return setTab(null);
  };

  const {
    actions: { resetPage },
  } = usePagination();

  const {
    category,
    actions: { setPaginatedCategory },
  } = useSessionCategory();

  const setPaginatedStatus = (newStatus: string) => {
    if (
      category === SESSION_CATEGORY.GROUP &&
      newStatus === SESSION_STATUS.PAST
    ) {
      setPaginatedCategory(null);
    }

    void setStatus(newStatus);
    resetPage();
  };

  const statusLabel = tab.status && getSessionStatusLabel(tab.status);

  return {
    status: tab.status,
    statusLabel,
    actions: { setPaginatedStatus },
  };
};
